import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLspOnboarding, LspCreation } from "./lspSlice";
import { fetchServices } from "../../../components/global-entities/globalEntitiesSlice";
const useLspOnboarding = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    activeIndex,
    onboardBtnEnable,
    nextBtnEnable,
    showOnboardBtn,
    generaldata,
    tradingdata,
    selectedServices,
    status,
    onboardeddata,
    isLeaveModal,
    serviceList,
  } = useSelector((state) => state.lsponboarding);

  const [personnelLists, setPersonnelList] = useState([]);

  const handleNext = () => {
    dispatch(
      setLspOnboarding({ key: "activeIndex", value: Number(activeIndex) + 1 }),
    );
  };
  const handleBack = () => {
    dispatch(
      setLspOnboarding({ key: "activeIndex", value: Number(activeIndex) - 1 }),
    );
  };

  useEffect(() => {
    handleClearState();
    dispatch(fetchServices());
  }, []);

  useEffect(() => {
    handleEnableNext();
  }, [personnelLists]);

  const handleEnableNext = () => {
    dispatch(
      setLspOnboarding({
        key: "showOnboardBtn",
        value: true,
      }),
    );
    if (activeIndex === 4) {
      if (personnelLists && personnelLists.length > 0) {
        dispatch(
          setLspOnboarding({
            key: "onboardBtnEnable",
            value: true,
          }),
        );
      } else {
        dispatch(
          setLspOnboarding({
            key: "onboardBtnEnable",
            value: false,
          }),
        );
      }
    }
  };
  const handleSave = () => {
    let addres = {
      ...tradingdata,
      city: tradingdata.city.name,
      country: tradingdata.country.code,
      state: tradingdata.state.code,
    };
    let data = {
      ...generaldata,
      service_url_override: serviceList.map((item) => ({
        [item.id]: [item.lsp_pay_url],
      })),
      active_services: serviceList.map((service) => service.id),
      start_date: generaldata?.start_date?.toString(),
      end_date: generaldata?.end_date?.toString(),
      addresses: addres,
      access: selectedServices,
      keypersonnels: personnelLists.map(({ id, ...rest }) => rest),
    };
    dispatch(LspCreation(JSON.stringify(data)));
  };

  const handleClearState = () => {
    dispatch(
      setLspOnboarding({
        key: "generaldata",
        value: {
          trading_name: "",
          start_date: null,
          end_date: null,
          phone: "",
          phone_code: "",
          email: "",
          hsp_manager_name: "",
          hsp_manager_email: "",
          account_manager_name: "",
          account_manager_email: "",
          account_manager_phone_code: "",
          account_manager_phone: "",
        },
      }),
    );
    dispatch(setLspOnboarding({ key: "tradingdata", value: null }));
    dispatch(setLspOnboarding({ key: "serviceList", value: [] }));
    dispatch(setLspOnboarding({ key: "selectedServices", value: [] }));
    dispatch(setLspOnboarding({ key: "activeIndex", value: 0 }));
    dispatch(setLspOnboarding({ key: "accessList", value: [] }));
    dispatch(setLspOnboarding({ key: "isLeaveModal", value: false }));
    setPersonnelList([]);
  };

  const handleViewLsp = () => {
    const lspid = onboardeddata?.lsp_id;
    console.log(lspid);
    dispatch(setLspOnboarding({ key: "isLeaveModal", value: false }));
    navigate(`/lsp/${lspid}/dashboard`);
  };

  const closeLspWizard = () => {
    navigate("/lsp");
  };

  return {
    gendata: {
      activeIndex,
      onboardBtnEnable,
      nextBtnEnable,
      showOnboardBtn,
      personnelLists,
      status,
      isLeaveModal,
    },
    handleNext,
    handleBack,
    setPersonnelList,
    handleSave,
    handleViewLsp,
    closeLspWizard,
    handleClearState,
  };
};

export default useLspOnboarding;
